import { ReactNode } from 'react';
import Footer from './Footer';
import Header from './Header';
import Background from './Background';
import ContactBar from '../ContactBar/ContactBar';
import { useTheme } from '@mui/material';
type MainLayoutProps = {
  children: ReactNode;
};

const MainLayout = ({ children }: MainLayoutProps) => {
  const theme = useTheme();
  return (
    <div style={{ backgroundColor: theme.palette.background.default }}>
      <Header />
      <Background />
      <ContactBar />
      {children}
      <Footer />
    </div>
  );
};

export default MainLayout;
